export { default } from './SkIcon'



// WEBPACK FOOTER //
// ./src/components/Common/Icon.js